import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { BusinessDetailsType } from ".";
import {
  DisableiIcon,
  EnableiIcon,
  RedCheckIcon,
  VerifyIcon,
  WhiteCheckIcon,
} from "../../../../assets/images";
import { PanVerifyType } from "../../../../redux/services/serviceTypes";
import { returnInputFieldLength } from "../../../../utils/commonFunctions";
import { RollingLoader } from "../../../commons";
import { useState } from "react";
import { CustomerSupplierListType } from "../../../../redux/clientSettings/clientSettingTypes";
import TableToggleSwitch from "../../../commons/TableToggleSwitch";

type AppProps = {
  businessDetails: BusinessDetailsType;
  handleBusinessDetailsChange: (e: any) => void;
  getGstDetails: (e: any) => void;
  legalNameError?: string;
  gstEerror?: string | null;
  success?: number | null;
  uniqueLegalNameMessage?: string | undefined | null;
  uniqueLegalNameFetching?: boolean;
  panVerifyDetails: PanVerifyType | null;
  getPanDetails: (e: any) => void;
  getBankDetails: (e: any) => void;
  customerSupplierData?: CustomerSupplierListType;
};

const CustomerSupplierBusinessDetails = ({
  businessDetails,
  handleBusinessDetailsChange,
  uniqueLegalNameMessage,
  uniqueLegalNameFetching,
  legalNameError,
  getGstDetails,
  getPanDetails,
  panVerifyDetails,
  success,
  customerSupplierData,
}: AppProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const {
    gst,
    tin,
    pan,
    msmeRegistrationNo,
    legalName,
    tradeName,
    registrationType,
    registrationDate,
    constitutionOfBusiness,
    companyStatus,
  } = businessDetails;
  return (
    <>
      {/* First Row */}
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-1">
              <div className="position-relative">
                <label htmlFor="PAN" className={pan ? "active" : ""}>
                  PAN Number
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="pan"
                  value={pan}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                />
                <span
                  className="position-absolute"
                  style={{ top: "30px", right: "5px" }}
                >
                  {(panVerifyDetails?.status === "VALID" &&
                    pan?.length === 10) ||
                  (customerSupplierData &&
                    customerSupplierData?.pan_details?.status === "VALID" &&
                    customerSupplierData?.pan_number === pan &&
                    pan?.length === 10) ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-filter-invoice">
                          <div>
                            <div className="text-left">
                              Full Name :{" "}
                              {panVerifyDetails?.full_name
                                ? panVerifyDetails?.full_name
                                : customerSupplierData?.pan_details?.full_name
                                ? customerSupplierData?.pan_details?.full_name
                                : "NA"}
                            </div>
                            <div className="text-left">
                              PAN No :{" "}
                              {panVerifyDetails?.pan
                                ? panVerifyDetails?.pan
                                : customerSupplierData?.pan_details?.pan
                                ? customerSupplierData?.pan_details?.pan
                                : "NA"}
                            </div>
                            <div className="text-left">
                              Category :{" "}
                              {panVerifyDetails?.category
                                ? panVerifyDetails?.category
                                : customerSupplierData?.pan_details?.category
                                ? customerSupplierData?.pan_details?.category
                                : "NA"}
                            </div>
                            <div className="text-left">
                              Status :{" "}
                              {panVerifyDetails?.status
                                ? panVerifyDetails?.status
                                : customerSupplierData?.pan_details?.status
                                ? customerSupplierData?.pan_details?.status
                                : "NA"}
                            </div>
                          </div>
                        </Tooltip>
                      }
                    >
                      <img src={EnableiIcon} />
                    </OverlayTrigger>
                  ) : (
                    <img src={DisableiIcon} />
                  )}
                </span>
                {(panVerifyDetails?.status === "VALID" && pan?.length === 10) ||
                (customerSupplierData &&
                  customerSupplierData?.pan_details?.status === "VALID" &&
                  customerSupplierData?.pan_number === pan &&
                  pan?.length === 10) ? (
                  <span>
                    <img src={VerifyIcon} alt="pan" />{" "}
                    <span style={{ color: "#28a745" }}>PAN is Verified</span>
                  </span>
                ) : panVerifyDetails?.status === "INVALID" ? (
                  <span className="text-danger">PAN is Invalid</span>
                ) : (
                  <span className="input-length">
                    {returnInputFieldLength(pan?.length, 10)}
                  </span>
                )}
              </div>        
            </div>
          </form>
        </div>
        <div className="col-md-2" style={{ marginTop: "10px" }}>
          <div className="form-group mt-3">
            <button
              className="btn btn-outline"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              disabled={pan && pan?.length > 9 ? false : true}
              onClick={(e) => {
                getPanDetails(e);
              }}
            >
              <img
                src={isHovered ? WhiteCheckIcon : RedCheckIcon}
                alt="check"
              />{" "}
              <span>Verify</span>
            </button>
          </div>
        </div>
           
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-1">
              <div>
                <label htmlFor="TIN" className={tin ? "active" : ""}>
                  TIN(VAT) Number
                </label>
                <input
                  type="text"
                  // onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="tin"
                  value={tin}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={11}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
              <span className="input-length">
                {returnInputFieldLength(tin?.length, 11)}
              </span>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-1">
              <div>
                <label
                  htmlFor="msmeRegistrationNo"
                  className={msmeRegistrationNo ? "active" : ""}
                >
                  MSME Registration Number
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="msmeRegistrationNo"
                  value={msmeRegistrationNo}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <span
          className="ml-3 mt-2"
          style={{ color: "#bfcbe1", marginBottom: "-10px" }}
        >
          Click button below to get GST details in form
        </span>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="GST" className={gst ? "active" : ""}>
                  GST Number
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="gst"
                  value={gst}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={15}
                />
              </div>
              <span className="input-length">
                {returnInputFieldLength(gst?.length, 15)}
              </span>
              {success == 0 && !!(gst?.length > 14) && (
                <p style={{ color: "#e7733e", fontSize: "10px" }}>
                  Invalid GST Number. Please try again.
                </p>
              )}
            </div>
          </form>
        </div>
        <div className="col-md-3 mt-4">
          <div className="form-group mt-3">
            <button
              className="btn btn-outline"
              disabled={gst && gst?.length > 14 ? false : true}
              onClick={(e) => getGstDetails(e)}
            >
              Verify and Get
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group">
              <div>
                <label
                  htmlFor="Legal Name"
                  className={legalName ? "active" : ""}
                >
                  Legal Name<span className="color-red">*</span>
                </label>
                <div className="d-flex flex-row position-relative">
                  <input
                    type="text"
                    className={`form-control ${
                      !!legalNameError ? "error-border" : null
                    }`}
                    name="legalName"
                    value={legalName}
                    onChange={(e) => handleBusinessDetailsChange(e)}
                  />
                  {uniqueLegalNameFetching && <RollingLoader />}
                </div>
                {!!legalNameError && (
                  <small className="text-danger">{legalNameError}</small>
                )}
                {uniqueLegalNameMessage?.includes("alredy") && (
                  <small className="text-warning">
                    Legal Name already exists!
                  </small>
                )}
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group">
              <div>
                <label
                  htmlFor="Trade Name"
                  className={tradeName ? "active" : ""}
                >
                  Trade Name
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="tradeName"
                  value={tradeName}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="Registration Type">Registration Type</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="registrationType"
                  value={registrationType}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                  disabled
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group ">
              <div>
                <label htmlFor="Registration Date">Registration Date</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="registrationDate"
                  value={registrationDate}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                  disabled
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="Constitution of Business">
                  Constitution of Business
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="constitutionOfBusiness"
                  value={constitutionOfBusiness}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                  disabled
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="Company Status">Company Status</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="companyStatus"
                  value={companyStatus}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                  disabled
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CustomerSupplierBusinessDetails;
